import { createAction } from 'typesafe-actions';
import { ACTIONS, ISelectionPayload } from './types';
import {
  IBets,
  IClientBet,
  IMakeBet,
  IMakeBetPayload,
  ISelection,
  Modes,
} from 'widgets/Roulette/types';

export const placeBetAction = createAction(ACTIONS.PLACE_BET)<IMakeBetPayload>();
export const refreshBetsAction = createAction(ACTIONS.REFRESH_BETS)<IBets>();

export const makeBetsAreaBetAction = createAction(ACTIONS.MAKE_BET_AREA_BET)<IMakeBetPayload>();
export const makeRaceTrackBetAction = createAction(ACTIONS.MAKE_RACE_TRACK_BET)<IMakeBet>();
export const makeStraightBetAction = createAction(ACTIONS.MAKE_STRAIGHT_BET)<IMakeBet>();

export const setSelectionAction = createAction(ACTIONS.SET_SELECTION)<ISelectionPayload | null>();
export const setSelectionOnRaceTrackAction = createAction(ACTIONS.SET_SELECTION_ON_RACE_TRACK)<
  ISelection[] | null
>();
export const setRaceTrackSelectionAction = createAction(
  ACTIONS.SET_RACE_TRACK_SELECTION,
)<IMakeBet | null>();

export const incrementNeighboursAction = createAction(ACTIONS.INCREMENT_NEIGHBORS)();
export const decrementNeighboursAction = createAction(ACTIONS.DECREMENT_NEIGHBORS)();
export const cancelLastBetAction = createAction(ACTIONS.CANCEL_LAST_BET)();
export const cancelAllBetsAction = createAction(ACTIONS.CANCEL_ALL_BETS)();

export const changeModeAction = createAction(ACTIONS.CHANGE_MODE)<{ mode: Modes }>();

export const saveWinnerToStoreAction = createAction(ACTIONS.SAVE_WINNER_TO_STORE)<{
  winner: string | null;
}>();

export const addConfirmedBetAction = createAction(ACTIONS.ADD_CONFIRMED_BET)<IClientBet[]>();
export const setConfirmedBetAction = createAction(ACTIONS.SET_CONFIRMED_BET)<IClientBet[]>();

export const clearAllBetsAction = createAction(ACTIONS.CLEAR_ALL_BETS)();
